import { ButtonOwnProps, ThemeOptions } from '@mui/material';
import { primary } from './colors.tsx';

declare module '@mui/material/Button' {
  interface ButtonPropsVariantOverrides {
    outlined: true;
    transparent: true;
    filled: true;
  }
}

export const themeButtonOptions: ThemeOptions['components'] = {
  MuiButton: {
    defaultProps: {
      disableElevation: true,
      disableRipple: true,
      disableFocusRipple: true,
    },
    styleOverrides: {
      root: {
        background: primary.main,
        borderRadius: 0,
        color: 'white',
        fontFamily: 'sans-serif!important',
        fontSize: '14px',
        '&:hover': {
          background: primary.light,
        },
        '&:disabled': {
          background: '#B3C5D1',
          color: 'white',
        },
        '&:focus': {
          outline: 'none',
        },
        variants: [
          {
            props: (props: ButtonOwnProps) => props.variant === 'outlined',
            style: {
              background: 'transparent',
              color: '#0D3B66',
              border: '1px solid #0D3B66',
              '&:hover': {
                background: '#F2F4F6',
              },
            },
          },
          {
            props: (props: ButtonOwnProps) => props.variant === 'transparent',
            style: {
              background: 'transparent',
              color: 'white',
              textAlign: 'center',
              '&:hover': {
                background: 'transparent',
                color: '#F2F4F6',
              },
            },
          },
          {
            props: (props: ButtonOwnProps) => props.variant === 'filled',
            style: {
              background: 'rgba(22, 69, 112, 0.05)',
              color: primary.main,
              textAlign: 'center',
              '&:hover': {
                color: 'black',
              },
              '&:focus': {
                background: primary.ultralight,
              },
            },
          },
        ],
      },
    },
  },
};
